import imageCompression from 'browser-image-compression';

const DEFAULT_OPTIONS = {
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  initialQuality: 0.85
};

export async function compressImageFile(file, overrides = {}) {
  if (!file) {
    return null;
  }
  try {
    const compressed = await imageCompression(file, {
      ...DEFAULT_OPTIONS,
      ...overrides
    });
    return compressed;
  } catch (error) {
    console.warn('Image compression failed; using original file.', error);
    return file;
  }
}

export async function compressFilesSequentially(files = [], overrides = {}) {
  const results = [];
  // Sequential processing keeps memory usage predictable for large batches.
  for (const file of files) {
    // eslint-disable-next-line no-await-in-loop
    const compressed = await compressImageFile(file, overrides);
    results.push(compressed);
  }
  return results;
}
